"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetLoginPwdWithOldPwd = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var password_1 = require("../../model/password");
var service_1 = require("../../../library/base/service");
var ResetLoginPwdWithOldPwd = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ResetLoginPwdWithOldPwd, _super);
    function ResetLoginPwdWithOldPwd() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '客户设置登录密码';
        _this.code = '101022';
        _this.desc = '客户设置登录密码';
        _this.requestParams = new password_1.ResetLoginPwdWithOldPwdRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return ResetLoginPwdWithOldPwd;
}(service_1.BaseService));
exports.ResetLoginPwdWithOldPwd = ResetLoginPwdWithOldPwd;
//# sourceMappingURL=resetLoginPwdWithOldPwd.js.map